import {useEffect, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import Swal from "sweetalert2";
import "./NavBarProfil.scss";
import ButtonDeconnect from "../../components/Button Deconnect/ButtonDeconnect";
import Cookies from "js-cookie";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faLocationDot,
    faCircleInfo,
    faHeart,
    faBasketShopping
} from "@fortawesome/free-solid-svg-icons";

function NavBarProfil() {
    const [infosPersoClique, setInfosPersoClique] = useState(false);
    const [commandesClique, setCommandesClique] = useState(false);
    const [adressesClique, setAdressesClique] = useState(false);
    const [favorisClique, setFavorisClique] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const userName = Cookies.get("name");
    const [name, setName] = useState(userName);
    const jwtToken = Cookies.get("auth_token");

    const isActive = (path) => location.pathname.includes(path) ? "active" : "";

    useEffect(() => {
        if (commandesClique) {
            const fetchData = async () => {
                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}commandes`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${jwtToken}`,
                            },
                        }
                    );
                    const commandes = await response.json();
                    commandes
                        ? navigate("/profil/commandes", {
                            state: {
                                commandes: commandes,
                            },
                        })
                        : navigate("/profil/commandes");
                } catch (error) {
                    console.error(error);
                } finally {
                    setCommandesClique(false);
                }
            };
            fetchData();
        }
    }, [commandesClique, jwtToken, navigate]);

    useEffect(() => {
        if (adressesClique) {
            const fetchData = async () => {
                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}adresses`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${jwtToken}`,
                            },
                        }
                    );
                    const adresses = await response.json();
                    adresses
                    && navigate("/profil/adresses");
                } catch (error) {
                    console.error(error);
                } finally {
                    setAdressesClique(false);
                }
            };
            fetchData();
        }
    }, [adressesClique, jwtToken, navigate]);

    useEffect(() => {
        if (infosPersoClique) {
            const fetchData = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_API_URL}users`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${jwtToken}`,
                        },
                    });

                    const user = await response.json();
                    if (user) {
                        navigate("/profil/infos-persos", {
                            state: {
                                nom: user.nom,
                                prenom: user.prenom,
                                adresseEmail: user.adresseEmail,
                                civilite: user.civilite,
                                numeroTel: user.numeroTel
                            },
                        });
                    } else {
                        Swal.fire({
                            text: "Erreur lors de la récupération de vos données ",
                            icon: "error",
                            confirmButtonText: "Ok",
                        });
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    setInfosPersoClique(false);
                }
            };

            fetchData();
        }
    }, [infosPersoClique, jwtToken, navigate]);


    useEffect(() => {
        if (favorisClique) {
            const fetchData = async () => {
                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}favoris`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${jwtToken}`,
                            },
                        }
                    );
                    const favoris = await response.json();
                    favoris
                        ? navigate("/profil/favoris", {
                            state: {
                                favoris: favoris,
                            },
                        })
                        : navigate("/profil/favoris");
                } catch (error) {
                    console.error(error);
                } finally {
                    setFavorisClique(false);
                }
            };
            fetchData();
        }
    }, [favorisClique, jwtToken, navigate]);

    return (
        <div className="navbar">
            <div className="navbar-header">
                <h3>Bonjour {name}</h3>
            </div>
            
            <button className={`nav-btn ${isActive("/profil/infos-persos")}`} onClick={() => setInfosPersoClique(true)}>
                <FontAwesomeIcon className="nav-icon" icon={faCircleInfo} />
                Mes Informations
            </button>
            <hr className="nav-divider" />
            
            <button className={`nav-btn ${isActive("/profil/adresses")}`} onClick={() => setAdressesClique(true)}>
                <FontAwesomeIcon className="nav-icon" icon={faLocationDot} />
                Mes adresses
            </button>
            <hr className="nav-divider" />
            
            <button className={`nav-btn ${isActive("/profil/commandes")}`} onClick={() => setCommandesClique(true)}>
                <FontAwesomeIcon className="nav-icon" icon={faBasketShopping} />
                Mes commandes
            </button>
            <hr className="nav-divider" />
            
            <button className={`nav-btn ${isActive("/profil/favoris")}`} onClick={() => setFavorisClique(true)}>
                <FontAwesomeIcon className="nav-icon" icon={faHeart} />
                Mes favoris
            </button>
            
            <div className="logout-container">
                <ButtonDeconnect />
            </div>
        </div>
    );
}

export default NavBarProfil;
